// LaunchDarkly flag keys for Farm Service V2 migration
export const FARM_CREATE_V2 = 'releaseBeFarmCreateV2';
export const FARM_CREATE_V2_BY_ORG = 'releaseBeFarmCreateV2ByOrg';
export const FARM_UPDATE_V2 = 'releaseBeFarmUpdateV2';
export const FARM_UPDATE_V2_BY_ORG = 'releaseBeFarmUpdateV2ByOrg';
export const FARM_DELETE_V2 = 'releaseBeFarmDeleteV2';
export const FARM_DELETE_V2_BY_ORG = 'releaseBeFarmDeleteV2ByOrg';
export const FARM_FETCH_V2 = 'releaseBeFarmFetchV2';
export const FARM_FETCH_V2_BY_ORG = 'releaseBeFarmFetchV2ByOrg';
export const FARMS_LIST_V2 = 'releaseBeFarmsListV2';
export const FARMS_LIST_V2_BY_ORG = 'releaseBeFarmsListV2ByOrg';
export const FARM_ARCHIVE_V2 = 'releaseBeFarmArchiveV2';
export const FARM_ARCHIVE_V2_BY_ORG = 'releaseBeFarmArchiveV2ByOrg';
export const FARM_UNARCHIVE_V2 = 'releaseBeFarmUnarchiveV2';
export const FARM_UNARCHIVE_V2_BY_ORG = 'releaseBeFarmUnarchiveV2ByOrg';
